import React from 'react';
import logo from '../images/logo.png';
import logosmall from '../images/logosmall.png';
import NavMenu from './NavMenu.tsx';
import { toast } from 'react-toastify';

let userClaims: any = null;

const TopMenu = () => {
    const [isAuthenticated, setIsAuthenticated] = React.useState(false);
    const [systemName, setSystemName] = React.useState("");
    const [userFirstName, setUserFirstName] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var req = new Request("/bff/user", {
            headers: new Headers({
                "X-CSRF": "1",
            }),
        });

        try {
            var resp = await fetch(req);
            if (resp.ok) {
                userClaims = await resp.json();
                setIsAuthenticated(true);
                getSystem();
                
            } else if (resp.status === 401) {
                setIsAuthenticated(false);
            }
        } catch (e) {
            setIsAuthenticated(false);
        }
    }

    const getSystem = async () => {
        const baseURL = window.location.origin;
        const apiURL = new URL('api/GetSystem', baseURL);

        var req = new Request(apiURL, {
            headers: new Headers({
                "X-CSRF": "1",
            }),
        });

        try {
            var resp = await fetch(req);
            if (resp.ok) {
                let data = await resp.json();
                setSystemName(data.systemName);
                setUserFirstName(data.userFirstName);
            }
        } catch (e) {
            toast.error("Error getting details!");
        }
    }

    const login = () => {
        window.location.replace("/bff/login");
    }

    function logout() {
        if (userClaims) {
            var logoutUrl = userClaims.find(
                (claim: any) => claim.type === "bff:logout_url"
            ).value;
            window.location.replace(logoutUrl);
        } else {
            window.location.replace("/bff/logout");
        }
    }


    return (
        <div>
            <div className="top-nav">
                <a className="hideMobile" href="/"><img className="logo" src={logo}></img></a>
                <a className="showMobile" href="/"><img className="logo" src={logosmall}></img></a>
                <div className={userFirstName === "" ? "hidden" : "hideMobile top-nav--fontsize"}>Welcome {userFirstName} </div>
                <div className={userFirstName === "" ? "hidden" : "showMobile"}>{userFirstName}</div>
                <div className={systemName ? "top-nav--fontsize error top-nav--background-red" : "hidden"}>{systemName}</div>
                <button id="login" type="button" className={isAuthenticated ? "hidden" : "logout-button"} onClick={login}>Login</button>
                <button id="logout" type="button" className={isAuthenticated ? "logout-button" : "hidden"} onClick={logout}>Logout</button>
            </div>
            <div className={isAuthenticated ? "" : "hidden"}>
                <NavMenu></NavMenu>
            </div>
        </div>
    );
}

export default TopMenu;